import {action, Action} from 'easy-peasy';

interface UserApiLogin {
    id: number;
    user_id: number;
    api_key: string;
    created_at: string;
    last_used?: string;
}

interface UserApiLoginsState {
    activeUser: number;
    setActiveUser: Action<UserApiLoginsState, number>;
    items: UserApiLogin[];
    loadUserLogins: Action<UserApiLoginsState, UserApiLogin[]>;
    searchPagesList: number[];
    setSearchPagesList: Action<UserApiLoginsState, number[]>;
    searchCurrentPage: number;
    setSearchCurrentPage: Action<UserApiLoginsState, number>;
    loading: boolean;
    setLoading: Action<UserApiLoginsState, boolean>;
}

const userApiLogins: UserApiLoginsState = {
    activeUser: 0,
    setActiveUser: action((state, activeUser) => {
        state.activeUser = activeUser;
    }),
    items: [],
    loadUserLogins: action((state, userLoginsList) => {
        state.items = userLoginsList;
    }),
    searchPagesList: [],
    setSearchPagesList: action((state, searchPagesList) => {
        state.searchPagesList = searchPagesList;
    }),
    searchCurrentPage: 1,
    setSearchCurrentPage: action((state, searchCurrentPage) => {
        state.searchCurrentPage = searchCurrentPage;
    }),
    loading: false,
    setLoading: action((state, loading) => {
        state.loading = loading;
    }),
};

export default userApiLogins;
